'use client';

import type { ComponentProps } from 'react';
import { useDevice } from '@/app/hooks';
import { Link } from '@/i18n/routing';

type ClientLinkProps = ComponentProps<typeof Link>;

export const ClientLink = ({ target = '_self', prefetch = false, ...props }: ClientLinkProps) => {
  const { os, isLenovoMini } = useDevice();

  return (
    <Link
      target={os === 'ios' || isLenovoMini ? '_self' : target}
      data-google-interstitial="false"
      prefetch={prefetch}
      {...props}
    >
      {props.children}
    </Link>
  );
};
